(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setHeaderHeightLive();

      window.addEventListener('resizeend', this.setHeaderHeight.bind(this));
      window.addEventListener('resizeend', this.setHeaderHeightLive.bind(this));
      this.headerResizeObserver = new ResizeObserver(() => {
        requestAnimationFrame(() => {
          this.setHeaderHeight();
          this.setHeaderHeightLive();
        });
      });
      this.headerResizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => { this.preventHide = false; });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setHeaderHeightLive(event, zero) {
      document.documentElement.style.setProperty('--header-height-live', `${zero ? 0 : this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.headerResizeObserver?.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  if (!customElements.get('header-menu')) {
    class HeaderMenu extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.closeTimer = null;

        this.addEventListener('mouseenter', this.open.bind(this));
        this.addEventListener('mouseleave', this.close.bind(this));
        this.addEventListener('focusin', this.open.bind(this));
        this.addEventListener('focusout', this.closeOnFocusOut.bind(this));
        this.summary?.addEventListener('click', this.handleSummaryClick.bind(this));
      }

      get isDesktopHover() {
        return window.matchMedia('(min-width: 990px) and (hover: hover)').matches;
      }

      handleSummaryClick(event) {
        if (!this.isDesktopHover || event.target instanceof Element && event.target.closest('a')) return;

        event.preventDefault();
        this.open();
      }

      open() {
        if (!this.isDesktopHover || !this.details) return;

        clearTimeout(this.closeTimer);
        this.closeSiblings();
        this.details.classList.remove('is-closing');
        this.details.setAttribute('open', '');
        this.summary?.setAttribute('aria-expanded', 'true');
      }

      close() {
        if (!this.details) return;

        clearTimeout(this.closeTimer);
        this.summary?.setAttribute('aria-expanded', 'false');

        if (!this.details.hasAttribute('open')) return;

        this.details.classList.add('is-closing');
        this.closeTimer = setTimeout(() => {
          this.details?.removeAttribute('open');
          this.details?.classList.remove('is-closing');
        }, 180);
      }

      closeOnFocusOut(event) {
        if (event.relatedTarget instanceof Node && this.contains(event.relatedTarget)) return;
        this.close();
      }

      closeSiblings() {
        this.closest('ul')?.querySelectorAll('header-menu').forEach((menu) => {
          if (menu !== this && typeof menu.close === 'function') {
            menu.close();
          }
        });
      }
    }

    customElements.define('header-menu', HeaderMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-3d-swing-comparison"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('error', (event) => {
  if (!event.target.matches?.('.home-3d-swing-comparison__media')) return;
  event.target.hidden = true;
  event.target.closest('.home-3d-swing-comparison__media-card')?.classList.add('home-3d-swing-comparison__media-card--failed');
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neopace-navigation-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseBeijing = (value) => {
      const match = /^([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9]{2}):([0-9]{2}):([0-9]{2})$/.exec(value.trim());
      if (!match) return NaN;
      const [, year, month, day, hour, minute, second] = match;
      const date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}+08:00`);
      // Validate Beijing calendar fields independently of the visitor's timezone.
      const beijing = new Date(date.getTime() + 8 * 60 * 60 * 1000);
      if (beijing.getUTCFullYear() !== Number(year) || beijing.getUTCMonth() + 1 !== Number(month) || beijing.getUTCDate() !== Number(day)
        || beijing.getUTCHours() !== Number(hour) || beijing.getUTCMinutes() !== Number(minute) || beijing.getUTCSeconds() !== Number(second)) return NaN;
      return date.getTime();
    };
    const pad = (value) => String(value).padStart(2, '0');
    const initialize = (root) => {
      if (root.dataset.neopaceCountdownReady) return;
      root.dataset.neopaceCountdownReady = 'true';
      const end = parseBeijing(root.dataset.endAtBeijing || '');
      const keepAfterEnd = root.dataset.showAfterEnd === 'true';
      if (!Number.isFinite(end)) { root.hidden = true; return; }
      let timer = null;
      let lastRemaining = Infinity;
      const update = () => {
        const rawSeconds = (end - Date.now()) / 1000;
        if (rawSeconds <= 0) {
          ['days', 'hours', 'minutes', 'seconds'].forEach((key) => { root.querySelector(`[data-countdown-part="${key}"]`).textContent = '00'; });
          if (keepAfterEnd) { root.removeAttribute('hidden'); } else { root.hidden = true; }
          if (timer) { clearInterval(timer); timer = null; }
          return;
        }
        const remaining = Math.ceil(rawSeconds);
        if (remaining > lastRemaining) return;
        lastRemaining = remaining;
        const days = Math.floor(remaining / 86400);
        const hours = Math.floor((remaining % 86400) / 3600);
        const minutes = Math.floor((remaining % 3600) / 60);
        const seconds = remaining % 60;
        root.querySelector('[data-countdown-part="days"]').textContent = pad(days);
        root.querySelector('[data-countdown-part="hours"]').textContent = pad(hours);
        root.querySelector('[data-countdown-part="minutes"]').textContent = pad(minutes);
        root.querySelector('[data-countdown-part="seconds"]').textContent = pad(seconds);
        root.removeAttribute('hidden');
      };
      update();
      if (!root.hidden) timer = setInterval(update, 1000);
      document.addEventListener('visibilitychange', update, { passive: true });
    };
    const scan = () => document.querySelectorAll('[data-neopace-countdown]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true }); else scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();
})();
